// Email preview rendering for the admin console.
// Mirrors supabase/functions/_shared/email.ts so the preview matches what is sent.

const escapeHtml = (s) =>
  s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');

export function fill(text, vars, html = true) {
  return (text || '').replace(/\{\{\s*([a-z_]+)\s*\}\}/g, (_m, name) => {
    const v = vars[name] ?? '';
    return html ? escapeHtml(String(v)) : String(v);
  });
}

export function renderTemplate(layout, tpl, vars) {
  const subject = fill(tpl.subject, vars, false).replace(/[\r\n]+/g, ' ').trim();
  const content = fill(tpl.body_html, vars);
  const shell = layout?.body_html || '{{content}}';
  const preheader = fill(tpl.preheader, vars, false);
  const html = fill(shell.replace('{{content}}', '\u0000CONTENT\u0000'), { ...vars, preheader })
    .replace('\u0000CONTENT\u0000', content);
  return { subject, html };
}

/** Sample values from a template's variable list. */
export const sampleVars = (tpl, appUrl = window.location.origin) => ({
  app_url: appUrl,
  ...Object.fromEntries((tpl?.variables || []).map((v) => [v.name, v.sample || ''])),
});

/** {{names}} used in a text that the template doesn't define. */
export function unknownVars(text, tpl, extra = []) {
  const known = new Set([...(tpl?.variables || []).map((v) => v.name), 'app_url', 'email', ...extra]);
  const used = [...(text || '').matchAll(/\{\{\s*([a-z_]+)\s*\}\}/g)].map((m) => m[1]);
  return [...new Set(used.filter((n) => !known.has(n)))];
}
